module.exports = __webpack_public_path__ + "static/media/culinaria.c7842304.svg";